// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import {
    CategorySearchCollectionModel,
    CategorySearchItemModel,
} from "@store/Framework/Services/CategorySearchService";
import { getSearchQuery } from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListSelectors";

export const getCategorySearchDataView = (state: ApplicationState) => {
    const query = getSearchQuery(state)?.trim() || "";
    return getDataView(state.data.pages, { categorySearch: true, query });
};

const getCategorySearchDataViewItems = (state: ApplicationState) => {
    const dataView = getCategorySearchDataView(state);
    const items = "properties" in dataView ? dataView.properties?.items : undefined;
    return Array.isArray(items) ? (items as CategorySearchItemModel[]) : [];
};

export const getCategorySearchItems = (state: ApplicationState): CategorySearchItemModel[] => {
    return getCategorySearchDataViewItems(state);
};

export const getCategorySearchCollection = (state: ApplicationState): CategorySearchCollectionModel => {
    const dataView = getCategorySearchDataView(state);
    const items = getCategorySearchDataViewItems(state);
    const totalItemCount = ("pagination" in dataView ? dataView.pagination?.totalItemCount : undefined) ?? items.length;

    return {
        items,
        totalItemCount,
    };
};
